import React, { useState } from 'react';
import './ManualRoomBookingModal.css';

interface ReservationSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  reservationData: {
    booking_id: number;
    reservation_id: string;
    payment_url: string;
    payment_link: string;
    expires_at: string;
    total_amount: number;
    room_amount: number;
    breakfast_amount?: number;
    dinner_amount?: number;
  } | null;
}

const ReservationSuccessModal: React.FC<ReservationSuccessModalProps> = ({ isOpen, onClose, reservationData }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen || !reservationData) return null;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(reservationData.payment_link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleWhatsAppShare = () => {
    const message = `🏨 Villa Polikne Rezervasyon

Rezervasyon No: ${reservationData.reservation_id}
Toplam Tutar: ₺${reservationData.total_amount.toLocaleString('tr-TR')}

Ödeme yapmak için lütfen aşağıdaki linke tıklayın:
${reservationData.payment_link}

⏰ Link geçerlilik süresi: ${new Date(reservationData.expires_at).toLocaleString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })}`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const expiresDate = new Date(reservationData.expires_at);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content success-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Rezervasyon Oluşturuldu</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="success-content">
          <div className="success-icon">✅</div>
          
          <h3>Rezervasyon Başarıyla Oluşturuldu!</h3>
          
          <div className="reservation-info">
            <div className="info-row">
              <span><strong>Rezervasyon No:</strong></span>
              <span>{reservationData.reservation_id}</span>
            </div>
            <div className="info-row">
              <span><strong>Booking ID:</strong></span>
              <span>#{reservationData.booking_id}</span>
            </div>
            <div className="info-row">
              <span><strong>Oda Tutarı:</strong></span>
              <span>₺{reservationData.room_amount.toLocaleString('tr-TR')}</span>
            </div>
            {reservationData.breakfast_amount && reservationData.breakfast_amount > 0 && (
              <div className="info-row">
                <span><strong>Kahvaltı:</strong></span>
                <span>₺{reservationData.breakfast_amount.toLocaleString('tr-TR')}</span>
              </div>
            )}
            {reservationData.dinner_amount && reservationData.dinner_amount > 0 && (
              <div className="info-row">
                <span><strong>Akşam Yemeği:</strong></span>
                <span>₺{reservationData.dinner_amount.toLocaleString('tr-TR')}</span>
              </div>
            )}
            <div className="info-row" style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#27ae60' }}>
              <span><strong>TOPLAM:</strong></span>
              <span>₺{reservationData.total_amount.toLocaleString('tr-TR')}</span>
            </div>
            <div className="info-row">
              <span><strong>Geçerlilik:</strong></span>
              <span>
                {expiresDate.toLocaleDateString('tr-TR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </span>
            </div>
          </div>

          <div className="payment-link-section">
            <h4>📎 Ödeme Linki</h4>
            <p style={{ fontSize: '0.9rem', color: '#666' }}>
              Bu linki müşteriye WhatsApp, SMS veya e-posta ile gönderebilirsiniz:
            </p>
            <div className="payment-link-box">
              {reservationData.payment_link}
            </div>
            
            <div className="link-actions">
              <button className="btn-copy" onClick={handleCopyLink}>
                {copied ? '✓ Kopyalandı!' : '📋 Linki Kopyala'}
              </button>
              <button className="btn-whatsapp" onClick={handleWhatsAppShare}>
                💬 WhatsApp'a Gönder
              </button>
            </div>
          </div>

          <div className="webhook-info">
            ℹ️ <strong>Otomatik Bildirim:</strong> n8n üzerinden müşteriye WhatsApp bildirimi gönderildi.
          </div>

          <div className="modal-actions" style={{ marginTop: '1.5rem' }}>
            <button className="btn-primary" onClick={onClose}>
              Tamam
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationSuccessModal;
